
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Checkout from "./pages/Checkout";
import ProductDetail from "./pages/ProductDetail";
import Search from "./pages/Search";
import Community from "./pages/Community";
import Support from "./pages/Support";
import NewsEvents from "./pages/NewsEvents";
import AhavexerDashboard from "./pages/AhavexerDashboard";
import CustomerDashboard from "./pages/CustomerDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import SellPortal from "./pages/SellPortal";
import Promotion from "./pages/Promotion";
import CartProvider from "./components/cart/CartProvider";

const App = () => (
  <TooltipProvider>
    <CartProvider>
      <Toaster />
      <Sonner />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/search" element={<Search />} />
        <Route path="/community" element={<Community />} />
        <Route path="/support" element={<Support />} />
        <Route path="/news-events" element={<NewsEvents />} />
        <Route path="/ahavexer-dashboard" element={<AhavexerDashboard />} />
        <Route path="/customer-dashboard" element={<CustomerDashboard />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/sell-portal" element={<SellPortal />} />
        <Route path="/promotion" element={<Promotion />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </CartProvider>
  </TooltipProvider>
);

export default App;
